import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useCart } from "../context/CartContext";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "../css/cartbutton.css";

const AddToCartButton = ({ product, quantity = 1, customClass = "" }) => {
  const [clicked, setClicked] = useState(false);
  const { addToCart } = useCart();
  const { t } = useTranslation();

  const stockQty = product?.stock_quantity ?? 0;
  const isOutOfStock = stockQty === 0;

  // useEffect(() => {
  //   console.log(`🛒 Product ID: ${product?._id}`);
  //   console.log(`📦 Stock Quantity: ${stockQty}`);
  //   console.log(`⛔ Out of Stock: ${isOutOfStock}`);
  //   console.log(`🧮 Selected Quantity: ${quantity}`);
  // }, [product, quantity]);

  const handleAddToCart = async () => {
    if (isOutOfStock) {
      toast.warning(t("product.itemOutOfStock"));
      return;
    }

    const productId = product?._id || product?.product_id;
    if (!productId) {
      toast.error(t("product.invalidProduct"));
      console.error("❗ Missing product ID in:", product);
      return;
    }

    setClicked(true);
    setTimeout(() => setClicked(false), 1500);

    try {
      await addToCart(productId, quantity); // ✅ Use selected quantity
      toast.success(t("product.addedToCart"), {
        position: "top-right",
        autoClose: 1500,
      });
    } catch (error) {
      console.error("Add to Cart Error:", error);
      toast.error(t("product.addToCartFailed"), {
        position: "top-right",
        autoClose: 1500,
      });
    }
  };

  return (
    <button
      className={`cart-button ${clicked ? "clicked" : ""} ${customClass}`}
      onClick={handleAddToCart}
      disabled={isOutOfStock}
    >
      {isOutOfStock ? (
        <span className="btn btn-danger w-100 "><p className="oos">{t("product.outOfStock")}</p></span>
      ) : (
        <>
          <span className="add-to-cart btn btn-warning w-100">{t("product.addToCart")}</span>
          <span className="added btn">{t("product.added")}</span>
          <i className="fas fa-shopping-cart cart-icon"></i>
          <i className="fas fa-box cart-item"></i>
        </>
      )}
    </button>
  );
};

export default AddToCartButton;
